import { drawImageFit } from "../utils/canvasUtils";


const easeInOut = (p) => p < 0.5
  ? 2 * p * p
  : 1 - Math.pow(-2 * p + 2, 2) / 2;


  const easeOut = (p) => 1 - Math.pow(1 - p, 3);

const clamp = (v) => Math.max(0, Math.min(1, v));

// ✅ PAN LEFT
export const drawPanLeft = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  p = easeInOut(p);
  const animOX = -p * canvas.width * 0.15;

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX + animOX,
    baseOffsetY
  );
};



// ✅ PAN RIGHT
export const drawPanRight = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  p = easeInOut(p);
  const animOX = p * canvas.width * 0.15;

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX + animOX,
    baseOffsetY
  );
};



// ✅ PAN UP
export const drawPanUp = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  p = easeInOut(p);
  const animOY = -p * canvas.height * 0.15;

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX,
    baseOffsetY + animOY
  );
};



// ✅ PAN DOWN
export const drawPanDown = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  p = easeInOut(p);
  const animOY = p * canvas.height * 0.15;

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX,
    baseOffsetY + animOY
  );
};



// ✅ KEN BURNS
export const drawKenBurns = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  p = easeInOut(p);
  //console.log("Ken Burns p:", p.canvas,baseScale,baseOffsetX,baseOffsetY);

  // ✅ Animation-only transforms
  const animScale = 1 + p * 0.15;
  const animOX = (p - 0.5) * canvas.width * 0.1;
  const animOY = (p - 0.5) * canvas.height * 0.05;

  // ✅ FINAL composition: base ⨉ anim
  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale * animScale,
    baseOffsetX + animOX,
    baseOffsetY + animOY
  );
};



// ✅ CAMERA SHAKE
export const drawCameraShake = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  const strength = 4 * Math.sin(p * Math.PI * 6);
  const dx = (Math.random() - 0.5) * strength;
  const dy = (Math.random() - 0.5) * strength;

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX + dx,
    baseOffsetY + dy
  );
};



// ✅ TILT
export const drawTilt = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  p = easeInOut(p);
  const angle = (p - 0.5) * 0.15;
  const animOX = (p - 0.5) * 40;

  ctx.save();
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate(angle);

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX + animOX - canvas.width / 2,
    baseOffsetY - canvas.height / 2
  );

  ctx.restore();
};




// ✅ BOUNCE
export const drawBounce = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  const animOY = Math.sin(p * Math.PI) * 18;

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX,
    baseOffsetY - animOY
  );
};



// ✅ FLASH POP
export const drawFlashPop = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale,
    baseOffsetX,
    baseOffsetY
  );

  const flash = Math.sin(p * Math.PI) * 0.8;
  if (flash > 0.05) {
    ctx.fillStyle = `rgba(255,255,255,${flash})`;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }
};



// ✅ ZOOM POP
export const drawZoomPop = (
  ctx,
  img,
  p,
  canvas,
  baseScale = 1,
  baseOffsetX = 0,
  baseOffsetY = 0
) => {
  p = easeOut(p);

  const pop = p < 0.4 ? p * 2.5 : 1 - (p - 0.4) * 0.3;
  const animScale = 1 + pop * 0.25;

  drawImageFit(
    ctx,
    img,
    canvas,
    baseScale * animScale,
    baseOffsetX,
    baseOffsetY
  );
};





export const ANIMATIONS = {
  "pan-left":  (ctx, img, p, c, s, ox, oy) =>
    drawPanLeft(ctx, img, p, c, s, ox, oy),

  "pan-right": (ctx, img, p, c, s, ox, oy) =>
    drawPanRight(ctx, img, p, c, s, ox, oy),

  "pan-up":    (ctx, img, p, c, s, ox, oy) =>
    drawPanUp(ctx, img, p, c, s, ox, oy),

  "pan-down":  (ctx, img, p, c, s, ox, oy) =>
    drawPanDown(ctx, img, p, c, s, ox, oy),

  "ken-burns": (ctx, img, p, c, s, ox, oy) =>
    drawKenBurns(ctx, img, p, c, s, ox, oy),

  "camera-shake": (ctx, img, p, c, s, ox, oy) =>
    drawCameraShake(ctx, img, p, c, s, ox, oy),

  "tilt": (ctx, img, p, c, s, ox, oy) =>
    drawTilt(ctx, img, p, c, s, ox, oy),

  "bounce": (ctx, img, p, c, s, ox, oy) =>
    drawBounce(ctx, img, p, c, s, ox, oy),

  "flash-pop": (ctx, img, p, c, s, ox, oy) =>
    drawFlashPop(ctx, img, p, c, s, ox, oy),

  "zoom-pop": (ctx, img, p, c, s, ox, oy) =>
    drawZoomPop(ctx, img, p, c, s, ox, oy),
};

